import { useEffect, useMemo, useRef } from "react";
import { canonicalSearchKey, type VersionSearch } from "@/urlState";

type Args = {
    page: number;
    search: VersionSearch;
    onReset: () => void;
};

export function useResetPageOnSearchChange({ page, search, onReset }: Args) {
    const searchKey = useMemo(() => canonicalSearchKey(search), [search]);
    const prevSearchKey = useRef(searchKey);

    useEffect(() => {
        if (prevSearchKey.current !== searchKey) {
            prevSearchKey.current = searchKey;
            if (page !== 1) {
                onReset();
            }
        }
    }, [page, searchKey, onReset]);
}
